import React from 'react';
import { IconArrowLeft, IconSearch, IconBinoculars404 } from '../../icons/svg';
import { SCREEN } from '../info-view-content.jsx';
import lodash from 'lodash'
import StringUtils from '../../lib/string';
import { Topic } from '../../tinode/topic'
import TimeHelpers from '../../lib/time';
import LetterTile from '../letter-tile.jsx'
import MessagesUtil from '../../tinode/messagesUtils';
import { NODE_TYPE_MESSAGE } from '../../tinode/constants';
import { profile } from '../../stores/storages/ProfileStorage';
import * as Const from '../../tinode/config'
import Contact404 from '../404/contact-404.jsx'
import MessageContent from '../../tinode/message-content'
import ArrayUtils from '../../lib/array.js';
import { Tinode } from '../../tinode/tinode'

export default class FindMessage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      placeholder: '',
      search: '',
      isSearching: false,
      listMessage: [],
      resultSearch: [],
      topic: null,
    }

    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.getTimeStr = this.getTimeStr.bind(this)
    this.handleShowMessage = this.handleShowMessage.bind(this)
  }

  componentDidMount() {
    const topic = this.props.tinode.getTopicByName(this.props.topic)
    console.log(topic)
    if (topic && lodash.has(topic, '_messages.buffer')) {
      // const listMessage = topic._messages.buffer
      this.props.tinode._db.readMessages(topic.name, { since: 0 }).then((listMessage) => {
        console.log("============listMessage", listMessage)
        this.setState({
          listMessage: listMessage.reverse(),
          topic,
        })
      })
      
    }
  }

  getTimeStr(time) {
    if (TimeHelpers.isCurrentDate(time)) {
      return TimeHelpers.getHHmm24(time)
    }
    return TimeHelpers.getDDMMYYYY(time)
  }


  handleSearchChange(e) {
    const query = e.target.value
    this.setState({
      search: query,
    });

    let isSearching = false
    if (query && query !== '') {
      isSearching = true
    }
    this.setState({
      isSearching,
    })

    if (this.findMessageTask) {
      clearTimeout(this.findMessageTask)
    }

    this.findMessageTask = setTimeout(() => {
      this.handleSearch(query);
    }, 300)
    
    
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') {
      this.handleClear(e);
    }
  }

  handleSearch(query) {
    const key = StringUtils.removeAccents(query)

    if (key === '') {
      this.handleClear()
    } else {
      if (key && key !== '') {
        const resultSearch = this.state.listMessage.filter((msg) => {
          if (msg && msg.subtype === 'text') {
            const msgContent = typeof msg?.content === 'string' ? msg?.content : msg?.content?.replyBody || ''
            return StringUtils.noAccentsMatch(msgContent, key)
          }
          return false;
        }).reverse()
        this.setState({
          resultSearch,
          isSearching: false,
        })
      }
    }
  }

  handleClear(e) {
    this.setState({
      search: '',
      resultSearch: [],
      isSearching: false,
    })
  }

  handleShowMessage(msg) {
    const seqId = msg.seq

    // Đóng tab info-view-content
    // this.props.onCancel()

    const topic = this.props.tinode.getTopicByName(this.props.topic)

    const filterFunc = obj => obj.seq === seqId
    const listMessages = ArrayUtils.getNeighbours(this.state.listMessage, filterFunc)
    const data = {
      listMessage: listMessages,
      topic,
      topicName: this.props.topic,
      seqId,
      keyWord: this.state.search,
    }
    this.props.onShowDialog(Tinode.DIALOG_TYPE.FIND_MESSAGE_RESULT, data)
  }

  renderMsg(msg) {
    if (msg) {
      const msisdn = Topic.getThreadId(msg.from)
      const from = msg.from === MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, profile.username) ? Const.TOPIC_ME : msg.from
      const topicFrom = this.props.tinode.getTopicByName(from)
      const avatar = lodash.has(topicFrom, 'public.photo.ref') ? topicFrom.public.photo.ref : true
      const fromName = Topic.getTopicName(topicFrom) || msisdn
      const time = this.getTimeStr(msg.ts)

      const msgContent = typeof msg?.content === 'string' ? msg?.content : msg?.content?.replyBody || ''
      const content = React.createElement(React.Fragment, null,
        MessageContent.renderContent(this.props.tinode, msgContent, { tags: msg.tags || [], tagAll: msg.tagAll || false }));

      return (
        <div
          className='result-msg'
          key={`search_result_${msg.id}`}
          onClick={(e) => { e.preventDefault(); this.handleShowMessage(msg) }}
        >
          <div className='msg-avatar'>
            <div className="avatar-box">
              <LetterTile
                tinode={this.props.tinode}
                avatar={avatar}
                topic={from}
                title={fromName}
              />
            </div>
          </div>
          <div className='msg-content'>
            <div className='msg-header'>
              <div className='msg-title'>
                {fromName}
              </div>
              <div className='msg-time'>{time}</div>
            </div>
            <div className='msg-body'>
              {content}
            </div>
          </div>

        </div>
      )
    }
    return ''
  }

  renderNoResult() {
    if (this.state.isSearching === false && this.state.search !== '') {
      return (
        <div className='not-found-contact' key={0} >
          <Contact404 iconEmpty={<IconBinoculars404 />} />
        </div>
      )
    }
    return ''
  }

  render() {
    return (
      <div className="info-image">
        <div className="header">
          <div className="icon" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}><IconArrowLeft /></div>
          <div className="" id="search-message-control">
            <div className="panel-form">
              <div className="panel-form-row">
                <i className="icon"><IconSearch /></i>
                <input className="search" type="text"
                  placeholder={this.props.placeholder}
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                  onKeyDown={this.handleKeyDown}
                  required
                  autoFocus
                />
              </div>
            </div>
          </div>
        </div>
        {this.state.isSearching && <div>...</div>}
        <div className='list-search-result'>
          {
            (Array.isArray(this.state.resultSearch) && this.state.resultSearch.length > 0) ?
              this.state.resultSearch.map(msg => this.renderMsg(msg)) : this.renderNoResult()
          }
        </div>
      </div >
    )
  }

}